<template>
  <el-popover
    v-model:visible="isOpen"
    placement="bottom-end"
    trigger="click"
    :persistent="true"
    :show-arrow="false"
    :popper-options="POPPER_OPTIONS"
    popper-style="width: 380px; height: 400px;"
  >
    <template #reference>
      <el-button
        text
        size="default"
        class="th:hover:text-th-primary el-button--text-icon title-button hidden"
        :aria-label="t('aichat.main.history.title')"
        data-testid="ai-chat-history-button"
      >
        <history-icon />
      </el-button>
    </template>

    <div class="w-full h-full flex flex-col overflow-x-hidden overflow-y-auto">
      <div class="flex flex-row flex-nowrap items-center border-b pb-2">
        <span class="text-black grow font-black">
          {{ t('aichat.main.history.title') }}
        </span>
        <el-button
          text
          size="default"
          class="th:hover:text-th-primary el-button--text-icon title-button"
          :aria-label="t('aichat.main.button.close')"
          data-testid="ai-chat-history-close-button"
          @click="isOpen = false"
        >
          <close-icon />
        </el-button>
      </div>
      <section v-for="group in historyItems" :key="group.name">
        <h3 class="text-sm font-normal pt-2 pl-2 border-b capitalize">
          {{ group.name }}
        </h3>
        <button
          v-for="item in group.items"
          :key="item.prompt"
          type="button"
          class="flex flex-row flex-nowrap items-center w-full text-left p-2 border-b text-sm cursor-pointer hover:bg-th-light-blue focus-visible:bg-th-light-blue"
          data-testid="ai-chat-history-item-button"
          @click="emit('click', item.prompt)"
        >
          <span
            class="grow text-black"
            data-testid="ai-chat-history-item-prompt"
            >{{ item.prompt }}</span
          >
          <span class="text-xs" data-testid="ai-chat-history-item-datetime">{{
            item.datetime
          }}</span>
        </button>
      </section>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { CloseIcon, HistoryIcon } from '@shared/assets/icons'
import { useChatHistory } from '../../constants/history'

const POPPER_OPTIONS = {
  modifiers: [{ name: 'offset', options: { offset: [26, 12] } }]
}

const emit = defineEmits<{
  click: [prompt: string]
}>()

const { t } = useI18n()
const { historyItems } = useChatHistory()

const isOpen = ref(false)
</script>
